<template>
  <a-drawer
    :title="title"
    :width="drawerWidth"
    @close="handleCancel"
    :visible="visible"
    :wrapStyle="{ height: 'calc(100% - 0px)', overflow: 'auto', paddingBottom: '0px' }"
  >
    <div :style="{ width: '100%', padding: '10px 16px', background: '#fff' }">
      <a-spin :spinning="loading">
        <a-form :form="form" @keyup.enter.native="handleOk">
          <a-form-item :label="$t('disp.menuType')" :labelCol="labelCol" :wrapperCol="wrapperCol">{{
            $t('disp.applyForm')
          }}</a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.flow.applyName')">{{
            name
          }}</a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.perms')">{{ perms }}</a-form-item>

          <!-- <a-form-item
            label="上级菜单"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            :validate-status="validateStatus"
            :hasFeedback="true"
            :required="true"
          >
            <span slot="help">{{ validateStatus=='error'?'请选择上级菜单':'&nbsp;&nbsp;' }}</span>
            <a-tree-select
              style="width:100%"
              :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
              :treeData="treeData"
              v-model="model.parentId"
              placeholder="请选择父级菜单"
              :disabled="disableSubmit"
              @change="handleParentIdChange"
            ></a-tree-select>
          </a-form-item>-->

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.flow.applyType')">
            <j-dict-select-tag
              v-decorator="['wfType', validatorRules.wfType]"
              :placeholder="$t('disp.ph.select', [$t('disp.flow.applyType')])"
              :type="'select'"
              :triggerChange="true"
              dictCode="wf_type"
            />
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.component')">
            <a-input
              :placeholder="$t('disp.ph.input', [$t('disp.component')])"
              v-decorator="['component', validatorRules.component]"
              :readOnly="disableSubmit"
            />
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="使用开始日">
            <a-date-picker placeholder="请选择使用开始日" style="width: 100%" v-decorator="['startDate', {}]" />
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="使用结束日">
            <a-date-picker placeholder="请选择使用结束日" style="width: 100%" v-decorator="['endDate', {}]" />
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.menuIcon')">
            <a-input
              :placeholder="$t('disp.ph.select', [$t('disp.menuIcon')])"
              v-model="model.icon"
              :readOnly="disableSubmit"
              :maxLength="100"
            >
              <a-icon slot="addonAfter" type="setting" @click="selectIcons" />
            </a-input>
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.sort')">
            <j-input-number
              style="width: 80px"
              v-decorator="['sortNo', validatorRules.sortNo]"
              :min="1001"
              :max="9999"
              :required="true"
              :formatter="null"
            />
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.phoneShow')">
            <a-switch :checkedChildren="$t('disp.yes')" :unCheckedChildren="$t('disp.no')" v-model="phoneShow" />
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.isAgentFlg')">
            <a-switch :checkedChildren="$t('disp.yes')" :unCheckedChildren="$t('disp.no')" v-model="isAgentFlg" />
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.alwaysShow')">
            <a-switch :checkedChildren="$t('disp.yes')" :unCheckedChildren="$t('disp.no')" v-model="alwaysShow" />
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设置禁用组织" v-if="alwaysShow">
            <j-input-popup
              style="margin-bottom: 16px"
              v-model="departs"
              component="SelectDepartTreeModal"
              placeholder="请选择禁用组织"
              :params="{
                companyId: '',
                departName: '',
                multiFlg: '1',
                departFlg: '1',
                searchFlg: '0',
              }"
            ></j-input-popup>
          </a-form-item>
        </a-form>

        <!-- iconを選択 -->
        <icons @choose="handleIconChoose" @close="handleIconCancel" :iconChooseVisible="iconChooseVisible"></icons>
      </a-spin>

      <a-divider style="margin: 10px 0 10px"></a-divider>

      <a-row style="text-align: right">
        <!-- <a-button :style="{marginRight: '8px'}" @click="handleCancel">关闭</a-button> -->
        <a-button :disabled="disableSubmit" @click="handleOk" type="primary" icon="check">{{
          $t('disp.btn.confirm')
        }}</a-button>
      </a-row>
    </div>
  </a-drawer>
</template>

<script>
import { addPermission, editPermission, queryTreeList } from '@/api/api'
import pick from 'lodash/pick'
import Icons from '@/views/k00/k0005/modules/icon/Icons.vue'
import JInputNumber from '@/components/JInputNumber'

export default {
  name: 'RelateMenuModal',
  components: { Icons, JInputNumber },
  data() {
    return {
      menuType: 2,
      name: '',
      perms: '',
      modelId: '',
      drawerWidth: 620,
      treeData: [],
      departs: [],
      treeValue: '0-0-4',
      title: '',
      visible: false,
      disableSubmit: false,
      model: {},
      alwaysShow: false, //フォーム要素-集合ルータ
      phoneShow: false, //フォーム要素-集合ルータ
      menuHidden: false, //フォーム要素-非表示ルータ
      routeSwitch: true, //メニューをルートするかどうか
      /*update_begin author:wuxianquan date:20190908 for:変数を定義する。初期値は内部オープン*/
      internalOrExternal: false, //メニューのオープン方
      /*update_end author:wuxianquan date:20190908 for:変数を定義する。初期値は内部オープン*/
      isKeepalive: true, //ルートをキャッシュするかどうか
      show: true, //メニューのタイプに応じて、フォーム要素をダイナミックに表示する（表示/隠し）
      isRequrie: true, // 検証するかどうか
      isAgentFlg: true, // 代理可否
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 17 },
      },

      loading: false,
      form: this.$form.createForm(this),

      iconChooseVisible: false,
      validateStatus: '',
    }
  },
  computed: {
    validatorRules: function () {
      return {
        wfType: { rules: [{ required: true, message: this.$t('disp.rules.require') }] },
        component: { rules: [{ required: true, message: this.$t('disp.rules.require') }] },
        sortNo: { initialValue: 1001.0 },
      }
    },
  },
  created() {},
  methods: {
    loadTree() {
      var that = this
      queryTreeList().then((res) => {
        if (res.success) {
          console.log('----queryTreeList---')
          console.log(res)
          that.treeData = []
          let treeList = res.result.treeList
          for (let a = 0; a < treeList.length; a++) {
            let temp = treeList[a]
            temp.isLeaf = temp.leaf
            that.treeData.push(temp)
          }
        }
      })
    },
    add() {
      // デフォルト
      this.edit({
        wfType: '999',
        status: '1',
        permsType: '1',
        agentFlg: '1',
        route: true,
        alwaysShow: false,
        phoneShow: false,
      })
    },
    edit(record) {
      this.resetScreenSize() // 画面の幅に応じてdrawerの幅を適応的に調整する
      this.form.resetFields()
      this.model = Object.assign({}, record)

      if (record.agentFlg == '1') {
        this.isAgentFlg = true
      } else {
        this.isAgentFlg = false
      }

      this.departs = []
      if (record.excludeDepartIds) {
        record.excludeDepartIds.split(',').forEach((r) => {
          this.departs.push({
            value: r,
            text: this.$getDepartTree(r, false).departName,
          })
        })
      }

      this.visible = true
      // this.loadTree()
      let fieldsVal = pick(this.model, 'wfType', 'component', 'sortNo', 'alwaysShow', 'phoneShow')
      this.$nextTick(() => {
        this.form.setFieldsValue(fieldsVal)
        //時間フォーマット
        this.form.setFieldsValue({
          startDate: this.model.startDate ? moment(this.model.startDate) : null,
          endDate: this.model.endDate ? moment(this.model.endDate) : null,
        })
      })
    },
    close() {
      this.$emit('close')
      this.disableSubmit = false
      this.visible = false
    },
    handleOk() {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      const that = this
      // フォーム検証をトリガー
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          let formData = Object.assign(this.model, values)
          // if (!formData.parentId) {
          //   that.validateStatus = 'error'
          //   return
          // } else {
          //   that.validateStatus = 'success'
          // }

          formData.menuType = this.menuType
          formData.name = this.name
          formData.perms = this.perms
          formData.url = formData.component.startsWith('/') ? formData.component : '/' + formData.component
          formData.hidden = true
          formData.agentFlg = this.isAgentFlg ? '1' : '0'
          formData.alwaysShow = this.alwaysShow
          formData.phoneShow = this.phoneShow

          // 非始终显示时,不必设置禁用组织
          if (!this.alwaysShow) {
            this.departs = []
            formData.excludeDepartIds = undefined
          } else if (this.departs.length > 0) {
            formData.excludeDepartIds = XEUtils.map(this.departs, (r) => r.value).join(',')
          } else {
            formData.excludeDepartIds = undefined
          }

          let obj
          if (!this.model.id) {
            obj = addPermission(formData)
          } else {
            obj = editPermission(formData)
          }
          obj
            .then((res) => {
              if (res.success) {
                if (!that.model.id) {
                  that.$message.success(this.$t('msg.insert.success'))
                } else {
                  that.$message.success(this.$t('msg.update.success'))
                }

                that.$emit('menuSaved', res.message, this.modelId)
              }
            })
            .finally(() => {
              that.loading = false
              that.close()
            })
        } else {
          that.loading = false
        }
      })
    },
    handleCancel() {
      this.close()
    },
    selectIcons() {
      this.iconChooseVisible = true
    },
    handleIconCancel() {
      this.iconChooseVisible = false
    },
    handleIconChoose(value) {
      console.log(value)
      this.model.icon = value
      this.form.icon = value
      this.iconChooseVisible = false
    },
    // 画面の幅に応じてdrawerの幅を調整する
    resetScreenSize() {
      let screenWidth = document.body.clientWidth
      if (screenWidth < 500) {
        this.drawerWidth = screenWidth
      } else {
        this.drawerWidth = 620
      }
    },
    handleParentIdChange(value) {
      if (!value) {
        this.validateStatus = 'error'
      } else {
        this.validateStatus = 'success'
      }
    },
  },
}
</script>

<style scoped></style>
